export const GLOBAL_FORM_VALIDATION_LABELS = 'global.formValidation';
export const lblErrEmailRequired = 'lbl_err_email_req';

const GlobalFormValidationLabels = {
  global: {
    formValidation: {
      [lblErrEmailRequired]: 'Please enter a valid email',
      "lbl_err_email": "Email format is invalid.",
      "lbl_err_req": "This field is required",
      "lbl_err_firstname_nonempty": "Please enter a first name",
      "lbl_err_firstname_name": "First name field should not contain any special Characters",
      "lbl_err_firstname_maxlength": "Please enter a valid first name",
      "lbl_err_lastname_nonempty": "Please enter a last name",
      "lbl_err_lastname_name": "Last name field should not contain any special characters or numbers",
      "lbl_err_lastname_maxlength": "Please enter a valid last name",
      "lbl_err_phonenumber_required": "Please enter a phone number",
      "lbl_err_phonenumber_phone": "Please enter a valid phone number",
      "lbl_err_zipcode_required": "Please enter a ZIP code",
      "lbl_err_zipcode_zipcode": " Enter correct zip code format",
      "lbl_err_password_required": "Please enter a valid password",
      "lbl_err_password_password": "Please enter a valid password",
      "lbl_err_currentpassword_password": "Please check the password & try again",
      "lbl_err_currentpassword_equalto": "Passwords must match",
      "lbl_err_dob_required": "Please enter a valid birth date",
      "lbl_err_airmilesaccountnumber": "Please enter a valid 11 digit Air Miles ID",
      "lbl_err_associateid": "The Associate ID you entered does not exist. Please try again.",
      "lbl_err_iagree": "Please review and agree to the My Place Rewards Program Terms & Conditions to create an account.",
      "lbl_err_ssnumber_ssn": "Please enter the last 4 digits of your social security number",
      "lbl_err_birthdate": "Please enter a valid date of birth",
      "lbl_err_statewocountry_required": "Please enter a valid state",
      "lbl_err_date_dob": "Please select a day",
      "lbl_err_month_dob": "Please select a month",
      "lbl_err_year_dob": "Please select a year",
      "lbl_err_ordernumber": "Please enter a valid order number.",
      "lbl_err_prescreencode": "Please enter a valid pre-screen code, or proceed without entering one",
      "lbl_err_confirmemailaddress_required": "Please confirm your email",
      "lbl_err_confirmemailaddress_matchemail": "Email addresses must match",
      "lbl_err_recaptchatoken_required": "Please check the recaptcha value",
      "lbl_err_cardnumber_required": "Please enter a card number",
      "lbl_err_cardnumber_type": "Please enter a card number",
      "lbl_err_cardnumber_plccenabled": "This card can only be used when shopping the US store",
      "lbl_err_giftcardnumber": "Please enter a valid gift card number",
      "lbl_err_cardpin": "Please enter your gift card pin number",
      "lbl_err_validstreetaddress": "Please enter a valid street address",
      "lbl_err_validexpirationedate": "Please enter a valid expiration date",
      "lbl_err_addressline1_address": "Please enter a valid address",
      "lbl_err_addressline1_maxlength": "Please shorten the street address",
      "lbl_err_addressline2_address": "Please enter a valid address",
      "lbl_err_city_nonempty": "Please enter a valid city",
      "lbl_err_city_city": "The value entered in the city has special character",
      "lbl_err_country_required": "Please select a country",
      "lbl_err_email_validemail": "Email format is invalid",
      "lbl_err_state_staterequired_us": "Please select a state",
      "lbl_err_state_staterequired_nonus": "Please select a province",
      "lbl_err_altphonenumber_notequalto": "Phone numbers must not match",
      "lbl_err_emailaddressnoasync": "ERROR: Email format is invalid",
      "lbl_err_cvvcode_required": "Please enter a valid security code",
      "lbl_err_cvvcode_cvvnumber": "Please enter a valid security code",
      "lbl_err_cvvcode_cvvlengththree": "Security code must be a 3-digit number without any spaces",
      "lbl_err_cvvcode_cvvlengthfour": "Security code must be a 4-digit number without any spaces",
      "lbl_err_userbirthdaymonth_required": "Please select a month",
      "lbl_err_userbirthdayyear_required": "Please select a year",
      "lbl_err_name_nonempty": "Please enter a name",
      "lbl_err_name_name": "Name field should not contain any special Characters",
      "lbl_err_name_maxlength": "Please enter a valid name",
      "lbl_err_gender_required": "Please select an option",
      "lbl_err_accept_tna_required": "Please accept the terms by selecting the box above.",
      "lbl_err_store_number_required": "Please enter the store number",
      "lbl_err_store_number_invalid": "Please enter a valid store number",
      "lbl_err_register_number_required": "Please enter a register number",
      "lbl_err_register_number_invalid": "Please enter a valid Register number",
      "lbl_err_transaction_date_required": "Please enter a transaction date",
      "lbl_err_transaction_number_required": "Please enter a transaction number",
      "lbl_err_transaction_number_invalid": "Please enter a valid value",
      "lbl_err_order_date_required": "Please enter the order date",
      "lbl_err_order_number_invalid": "Please enter the order number",
      "lbl_err_prefix": "",
      "lbl_err_subject_required": "Please enter a subject line for the email",
      "lbl_err_message_required": "Please enter a message for the email",
      "lbl_err_toemail_required": "Please enter one or more email addresses, separated by commas",
      "lbl_err_listname_required": "Please enter name for the favorite list",
      "lbl_err_expmonth_required": "Please enter a exp. month",
      "lbl_err_expyear_required": "Please enter a exp. year",
      "lbl_err_expYear": "Please enter expiry year",
      "lbl_err_expMonth": "Please enter expiry month",
      "lbl_resend_email_modal_heading": "Resend Confirmation",
      "lbl_resend_email_modal_description": "Enter email address to send confirmation",
      "lbl_resend_email_placeHolder": "Email Address",
      "lbl_resend_email_send_button": "Send Email",
      "lbl_err_cardnumber_non_cc": "Enter your My Place Rewards Credit Card in the appropriate section below",
      "lbl_err_cardnumber_non_plcc": "Enter a valid My Place Rewards Credit Card number",
      "lbl_err_cardnumber_non_cc_Mob": "Using your My Place Rewards Credit Card? Enter it on the previous screen.",
      "lbl_credit_card_valid": "Please enter valid input",
      "lbl_err_password_notEqualto": "Cannot be your email address or a recent password"
    },
  },
};

export default GlobalFormValidationLabels;
